import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import GrantForm from '@/ui/pages/UserAccess/GrantForm';

export const Route = createFileRoute('/_dashboard/users/$id/$tenantId/access/new')({
  beforeLoad: requireRoute('/users/$id/$tenantId/access/new'),
  component: GrantForm,
});
